/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Task_Stage_ChangedInputs */

const cs_event_task_stage_changed = /** @type {(inputs: Event_Task_Stage_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna fáze úkolu`)
};

const en_event_task_stage_changed = /** @type {(inputs: Event_Task_Stage_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task stage changed`)
};

/**
* | output |
* | --- |
* | "Task stage changed" |
*
* @param {Event_Task_Stage_ChangedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_task_stage_changed = /** @type {((inputs?: Event_Task_Stage_ChangedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Task_Stage_ChangedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_task_stage_changed(inputs)
	return cs_event_task_stage_changed(inputs)
});